export default "__VITE_ASSET__QoYHqrCX__"